import { render, staticRenderFns } from "./xmlRobot.vue?vue&type=template&id=dcd1d1ec&scoped=true&"
import script from "./xmlRobot.vue?vue&type=script&lang=js&"
export * from "./xmlRobot.vue?vue&type=script&lang=js&"
import style0 from "./xmlRobot.vue?vue&type=style&index=0&id=dcd1d1ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd1d1ec",
  null
  
)

export default component.exports